// 此文件 -> 封装3个方法 -> 专门用于操作token
// 封装东西，目的 -> 代码分层，更方便清晰，以后修改方便

const key = 'gym-token'
// 设置
export const setToken = (token) => {
  sessionStorage.setItem(key, token)
}
// 获取
export const getToken = () => sessionStorage.getItem(key)
// 删除
export const delToken = () => {
  sessionStorage.removeItem(key)
}

export const clearLogin = () => {
  delToken()
  localStorage.removeItem('loginId')
}
